import React from "react";
import { Set } from "immutable";

import Wrapper from "./Wrapper";
import Property from "../../Property";
import FormContext from "./FormContext";

/**
 * The Schema.org form listing the Schema.org properties.
 *
 * @since 1.0.0
 */
class Form extends React.Component {
  constructor(props) {
    super(props);

    // Handle Schema Class added to selection.
    this.onAdd = this.onAdd.bind(this);

    // Handle Schema Class removed from selection.
    this.onRemove = this.onRemove.bind(this);

    // Receive properties data for selected classes.
    this.onData = this.onData.bind(this);

    if (props.selectionListener)
      props.selectionListener(this.onAdd, this.onRemove);
    if (props.loader) this.loader = props.loader;
    if (props.propertyDecorator)
      this.propertyDecorator = props.propertyDecorator;
    if (props.propertyInstanceDecorator)
      this.propertyInstanceDecorator = props.propertyInstanceDecorator;

    this.DecoratedProperty = this.propertyDecorator(Property);

    this.state = {
      properties: [],
      // Selected Schema Classes.
      selected: Set(props.selected)
    };
  }

  //region ## LIFE-CYCLE
  /**
   * After the component did mount, load the properties.
   *
   * @since 1.0.0
   */
  componentDidMount() {
    this.loader(this.state.selected).then(this.onData);
  }

  /**
   * After the component did update the selection, reload the properties.
   *
   * @since 1.0.0
   * @param prevProps
   * @param prevState
   * @param snapshot
   */
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.selected !== this.state.selected)
      this.loader(this.state.selected).then(this.onData);
  }
  //endregion

  onData(json) {
    this.setState({ properties: json });
  }

  onAdd(value) {
    this.setState(prevState => ({
      selected: prevState.selected.add(value.name)
    }));
  }

  onRemove(value) {
    this.setState(prevState => ({
      selected: prevState.selected.remove(value.name)
    }));
  }

  propertyDecorator(Component) {
    return Component;
  }

  render() {
    return (
      <Wrapper>
        <FormContext.Provider
          value={{
            loader: this.loader,
            propertyDecorator: this.propertyDecorator,
            propertyInstanceDecorator: this.propertyInstanceDecorator
          }}
        >
          {this.state.properties.map((property, key) => (
            <this.DecoratedProperty
              key={key}
              property={property}
              propertyInstanceDecorator={this.propertyInstanceDecorator}
            />
          ))}
        </FormContext.Provider>
      </Wrapper>
    );
  }
}

export default Form;
